// extracted by mini-css-extract-plugin
export default {"infoPanel":"InfoPanel_infoPanel__nvEEe","infoPanelWrapper":"InfoPanel_infoPanelWrapper__0HZNs"};